export default __webpack_public_path__ + "fc0259fcff359c52b3719b00be588e0e.png";